module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update_customer_address":"Update customer address"},"id":{"update_customer_address":"Perbarui Alamat Pelanggan"}}')
  delete Component.options._Ctor
}
